import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CollectionLink from "../../utils/generate-collection-link";
import CollectionTitle from "../../atoms/CollectionTitle";
import styles from "./styles.m.css";
import { getStoryHeadline } from "../../utils/utils";
import Icon from "../../atoms/icon";
import StoryCardVertical from "../../atoms/story-card-vertical";
import BigStoryCardCurve from "../../atoms/big-story-card-curve";
import SmallStoryCardCurve from "../../atoms/small-story-card-curve";
import { VikatanTweleCollectionAd } from "../ad-free";
import ElectionMapComponent from "../../pages/vikatan-election-map";
import ConstituencyDirectSearch from "../../atoms/constituency-direct-search";

const TweleStoryCollectionWithAdMap = ({
  collection,
  accentColor,
  authorName = true,
  utmURL = "",
  homecollection = false,
  storyLimit,
  textOverleyCard
}) => {
  const { name, items } = collection;
  const [userType = "F", setType] = useState(false);
  // If user is paid (userType === "P"), show 12 stories; else show 16 stories
  const effectiveStoryLimit = userType === "P" ? 12 : 20;
  const stories =
    items
      .filter(({ story = {} }) => getStoryHeadline(story) && story.url)
      .slice(0, effectiveStoryLimit)
      .map(({ story }) => story) || [];

  if (!stories.length) {
    return null;
  }

  const bigStory = stories[0];
  // Adjust story distribution based on effectiveStoryLimit: 4+7 for 12, 6+9 for 16
  const leftListSize = effectiveStoryLimit === 12 ? 5 : 8;
  const rightListSize = effectiveStoryLimit === 12 ? 8 : 11;
  const leftListStories = stories.slice(1, leftListSize);
  const rightListStories = stories.slice(leftListSize, leftListSize + rightListSize);
  // const [iframeKey, setIframeKey] = useState(0);
  // const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      setType(user.userType);
    });
  }, []);

  return (
    <div
      className={`container ${styles["collection-wrapper"]} ${
        homecollection ? styles["home-card"] : styles["not-home-card"]
      }`}
    >
      <div className={styles["left-section"]}>
        <CollectionLink collection={collection} disableAppSlugCheck={true} className={`${styles["title-grid"]}`}>
          <div className={styles["title-container"]}>
            <CollectionTitle className={styles.title} title={name} />
            <Icon type="slider-next" className={styles["arrow-icon"]} />
          </div>
        </CollectionLink>

        <div className={styles["stories-content"]}>
          <div className={styles["left-column"]}>
            <BigStoryCardCurve
              story={bigStory}
              className={styles["big-story-card"]}
              bigimage={true}
              videocard={true} // Using videocard for Horizontal layout (Image Left, Text Right)
              textOverleyCard={true}
              pFrom="twele-stories-map"
            />
            <div className={styles["left-list"]}>
              {leftListStories.map(story => (
                <SmallStoryCardCurve
                  key={story.id}
                  story={story}
                  className={styles["small-story-card"]}
                  horizondalImage={true}
                  pFrom="twele-stories-map"
                  hideImage={true}
                />
              ))}
            </div>
          </div>
          <div className={styles["right-column"]}>
            {rightListStories.map(story => (
              <SmallStoryCardCurve
                key={story.id}
                story={story}
                className={styles["small-story-card"]}
                horizondalImage={true}
                pFrom="twele-stories-map"
                hideImage={true}
              />
            ))}
          </div>
        </div>
      </div>

      <div className={styles["right-section"]}>
        <VikatanTweleCollectionAd />

        <div className={styles["map-widget"]}>
          <h3 className={styles["map-header"]}>
            <span>தொகுதி 360</span>
          </h3>
          <div className={styles["map-subtext"]}>தேர்தல் கள நிலவரங்களை அறிந்துகொள்ள</div>
          <ElectionMapComponent />
          <div className={styles["or-divider"]}>
            <span className={styles["or-line"]} />
            <span className={styles["or-text"]}>OR</span>
            <span className={styles["or-line"]} />
          </div>
          <div className={styles["search-widget"]}>
            <div className={styles["search-box"]}>
              <ConstituencyDirectSearch />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TweleStoryCollectionWithAdMap.propTypes = {
  accentColor: PropTypes.string,
  authorName: PropTypes.bool,
  utmURL: PropTypes.string,
  homecollection: PropTypes.bool, // Fixed propType
  storyLimit: PropTypes.number,
  openInNewTab: PropTypes.bool,
  textOverleyCard: PropTypes.bool,
  collection: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    slug: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(StoryCardVertical.propTypes))
  })
};
TweleStoryCollectionWithAdMap.storyLimit = 25;

export default TweleStoryCollectionWithAdMap;
